export class PropertyTaskDTO{
    public id?:number;
    public propertyId!:number;
    public taskType!:string;
    public task!:string; //json
}